import { createContext, useContext } from "react";

export const ROLE_LABEL = { owner: "Owner", admin: "Admin", pastor: "Pastor", director: "Care Director", leader: "Care Leader" };
export const roleLabel = (m, role) => m?.role_labels?.[role] || ROLE_LABEL[role];
const ROLE_WORDS = /(?<!Assigned )\b(Care Directors|Care Leaders|Pastors|Owners|Admins|Care Director|Care Leader|Pastor|Owner|Admin)\b/g;
const WORD_ROLE = { "Care Director": "director", "Care Leader": "leader", Pastor: "pastor", Owner: "owner", Admin: "admin" };
export const roleText = (m, s) => (m?.role_labels ? s.replace(ROLE_WORDS, (w) => {
  const plural = !WORD_ROLE[w];
  const label = roleLabel(m, WORD_ROLE[plural ? w.slice(0, -1) : w]);
  return plural ? `${label}s` : label;
}) : s);
export const ROLE_ORDER = ["owner", "pastor", "director", "leader", "admin"];
export const ROLE_DESC = {
  owner: "Full access, including church settings, roles, integrations and confidential notes.",
  pastor: "Oversees pastoral care across the whole church. Can be given Confidential Access by the Owner.",
  director: "Coordinates Care Leaders and Care Assignments for the whole church or chosen Care Groups. No settings, roles or confidential notes.",
  leader: "Cares for the people entrusted to them and their Care Groups, logs care and completes assignments.",
  admin: "Manages the directory, Care Groups, team and settings. Doesn't see pastoral care details.",
};
export const OrgContext = createContext(null);
export const useOrg = () => useContext(OrgContext);

export const can = (m) => ({
  team: ["owner", "admin", "pastor"].includes(m.role),
  manage: ["owner", "admin"].includes(m.role),
  owner: m.role === "owner",
  audit: m.role === "owner" || (m.role === "pastor" && m.confidential_access),
  directory: ["owner", "admin", "pastor"].includes(m.role),
  care: ["owner", "pastor"].includes(m.role),
  oversee: ["owner", "pastor", "director"].includes(m.role),
  leader: m.role === "leader",
  seesCare: m.role !== "admin",
});
